<template>
  <div class="debug">
    <!--顶部-->
    <div class="trendtop orangeToYellow">
      <div class="trendtop_left fs40 ellipsis" @click="showChangeTrend">
        <p>{{ choselist.deviceName }}</p>
      </div>
      <div class="trendtop_right fs24">
        <!-- <img src="../../../assets/images/refresh.png" class="img1 animate" @click="doReferesh" /> -->
      </div>
    </div>
    <div class="ctn" ref="ctn" @scroll="handleScroll">
      <div v-if="choselist.type !== 6">请选择解码器设备</div>
      <!-- RTU相关信息 -->

      <div v-else class="fm">
        <Table :column="column" :dataSource="fmList" :top="top" />
      </div>
      <van-popup
        v-model="ishow"
        position="bottom"
        :style="{ height: '40%' }"
        @click-overlay="onCancel"
      >
        <van-picker
          :title="$t('trend.trend_chose')"
          :confirm-button-text="$t('member.login_out_ok')"
          :cancel-button-text="$t('member.login_out_cancel')"
          show-toolbar
          :columns="monlist"
          :default-index="des"
          @confirm="onConfirm"
          @cancel="onCancel"
        />
      </van-popup>
    </div>
  </div>
</template>

<script>
import Table from '@/components/slidTable';

export default {
  components: {
    Table
  },

  data() {
    return {
      ishow: false,
      choselist: {}, // 当前选中的设备
      no: localStorage.getItem('no') ? localStorage.getItem('no') : '',
      monlist: [],
      devicelist: [],
      des: null,
      fmList: [],
      column: [
        {
          title: '阀门名称',
          dataIndex: 'portName',
          key: 'portName'
        },
        {
          title: '编号',
          dataIndex: 'rtuNo',
          key: 'rtuNo'
        },
        {
          title: '端口',
          dataIndex: 'port',
          key: 'port'
        },
        {
          title: '开关',
          dataIndex: 'state',
          key: 'state'
        },
        {
          title: '信号强度',
          dataIndex: 'signal',
          key: 'signal'
        },
        {
          title: '电压',
          dataIndex: 'voltage',
          key: 'voltage'
        },
        {
          title: '更新时间',
          dataIndex: 'time',
          key: 'time'
        }
      ],
      top: 0
    };
  },

  created() {
    this.no = localStorage.getItem('no') ? localStorage.getItem('no') : '';
    this.getDeviceList();
  },

  methods: {
    //查询设备列表
    async getDeviceList() {
      this.$toast.loading({
        message: this.$t('live.read_loading'),
        forbidClick: true,
        duration: 0
      });

      await this.$api
        .getDeviceList()
        .then(res => {
          try {
            this.$toast.clear();
            if (res.errcode == 0) {
              var des = this.des;
              var devicelist = res.data;
              var choselist = '';
              var monlist = new Array();
              if (!this.$isblank(devicelist)) {
                if (this.$isblank(this.no)) {
                  des = 0;
                } else {
                  for (var i = 0; i < devicelist.length; i++) {
                    if (devicelist[i].no == this.no) {
                      des = i;
                    }
                  }
                }
                for (var i = 0; i < devicelist.length; i++) {
                  monlist.push(devicelist[i].deviceName);
                }

                choselist = devicelist[des];
                this.choselist = choselist;
                this.devicelist = devicelist;
                this.des = des;
                this.monlist = monlist;

                // 如果设备是 解码器 则请求RTU信息
                choselist.type === 6 && this.getRTUInfo(choselist.no);
              } else {
                //没有设备列表
                this.choselist = {};
                this.devicelist = [];
                this.des = null;
                this.monlist = [];
              }
            } else {
              //其他异常
              this.$toast.clear();
              this.$toast(this.$t('common.nodata'));
            }
          } catch (err) {
            console.error(err);
          }
        })
        .catch(err => {
          //其他异常
          this.$toast.clear();
        });
    },

    // 获取RTU信息
    async getRTUInfo(no) {
      await this.$api
        .getRtuList({
          gatewayNo: no,
          page: 1,
          pageSize: 5
        })
        .then(res => {
          if (res.errcode === 0) {
            if (!this.$isblank(res.data)) {
              let rtuList = [...res.data];
              let portsList = [];
              rtuList.map((item, index) => {
                if (item.valves && item.valves.length) {
                  item.valves.map(_item => {
                    _item = {
                      ..._item,
                      rtuNo: item.no,
                      systemTimestamp: item.systemTimestamp,
                      nameFirst: _item.portName[0],
                      nameSecod: _item.portName.match(/\d{1,}/g)[0],
                      voltage: item.voltage,
                      signal: item.signal
                    };
                    portsList.push(_item);
                  });
                }
              });

              const list = [...this.sortRTU(portsList)];
              this.fmList = [...list];
              console.log('list:', list);
            }
          }
        });
    },

    sortRTU(rtuList) {
      const data = [...rtuList];
      let reg = /\d{1,}/g;
      let names = [];
      let group = new Set();
      // 先分组
      let groupTrunk = [];

      if (data && data.length) {
        data.map(item => {
          group.add(item.nameFirst);
        });
        group = Array.from(group).sort();
        group.map(groupId => {
          let arr = [];
          data.map(item => {
            if (groupId === item.nameFirst) {
              arr.push(item);
            }
          });
          groupTrunk = groupTrunk.concat(this.sortGroup(arr));
        });
      }

      groupTrunk.map(item => {
        names.push(item.portName);
      });

      return groupTrunk;
    },

    sortGroup(data) {
      // 第二排序条件
      return data.sort((a, b) => {
        let _a = Number(a.nameSecod);
        let _b = Number(b.nameSecod);
        return _a - _b;
      });
    },

    //设备选择
    showChangeTrend() {
      this.ishow = true;
      this.ischange = true;
    },

    // 设备选择取消
    onCancel() {
      this.ischange = false;
      this.ishow = false;
    },

    // 选择设备 判断是否是解码器，然后请求RTU相关信息
    onConfirm(value, index) {
      let t = this.devicelist[index];
      this.choselist = { ...t };
      t.type === 6 && this.getRTUInfo(t.no);
      this.onCancel();
    },

    handleScroll() {
      console.log('123');
      this.top = this.$refs.ctn.scrollTop;
    },

    cb(top) {
      this.$refs.ctn.scrollTop = top;
    }
  }
};
</script>

<style lang="scss" scoped>
.debug {
  height: 100%;
  overflow: hidden;
}

.trendtop {
  height: 60px;
  overflow: hidden;
  line-height: 30px;
  padding: 15px 10px;
  width: 100%;
  box-sizing: border-box;
  z-index: 9999999999;
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.3);
}

.ctn {
  height: calc(100% - 60px);
  overflow-y: scroll;
}

.trendtop .trendtop_left {
  float: left;
  color: #fff;
  padding: 0 0.4rem 0 0;
  position: relative;
  max-width: 3rem;
  font-size: 15px;
  font-weight: 700;
}

.trendtop .trendtop_left .number {
  font-size: 13px;
  font-weight: normal;
  opacity: 0.7;
  line-height: 1;
}

.trendtop .trendtop_left::after {
  position: absolute;
  content: '';
  width: 0.14rem;
  height: 0.14rem;
  border-top: 2px solid #fff;
  border-right: 2px solid #fff;
  transform: rotate(45deg);
  top: 50%;
  margin-top: -0.09rem;
  right: 0.1rem;
  -webkit-transition: all 0.3s ease 0s;
  -o-transition: all 0.3s ease 0s;
  transition: all 0.3s ease 0s;
}

.trendtop .trendtop_left.on::after {
  -webkit-transform: rotate(135deg);
  -moz-transform: rotate(135deg);
  -o-transform: rotate(135deg);
  -ms-transform: rotate(135deg);
  transform: rotate(135deg);
}

.trendtop .trendtop_right {
  float: right;
  overflow: hidden;
  color: #fff;
  opacity: 0.5;
  font-weight: 700;
  font-size: 12px;
  height: 30px;
  line-height: 30px;
  position: relative;
  padding-right: 16px;
}

.trendtop .trendtop_right .img1 {
  width: 12px;
  height: 12px;
  float: right;
  margin-left: 5px;
  position: absolute;
  top: 50%;
  margin-top: -6px;
  right: 0;
}

.trendtop .trendtop_right .img1.on {
  animation: run 2s linear 0s infinite;
}

.fm {
  font-size: 14px;

  .tit {
    display: flex;
    span {
      flex: 1;
    }
  }
}
.fm-item {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  text-align: center;

  span {
    display: block;
    flex: 1;
  }

  span.port,
  span.switch {
    width: 20px;
    flex: none;
  }
}
</style>
